import { createSvg } from '../createSvg';

const Key = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <g id={'contour'}>
        <path
            d='M18.7897 13.9303C16.7297 15.9803 13.7797 16.6103 11.1897 15.8003L6.47966 20.5003C6.13966 20.8503 5.46966 21.0603 4.98966 20.9903L2.80966
            20.6903C2.08966 20.5903 1.41966 19.9103 1.30966 19.1903L1.00966 17.0103C0.939658 16.5303 1.16966 15.8603 1.49966 15.5203L6.19966 10.8203C5.39966
            8.22031 6.01966 5.27031 8.07966 3.22031C11.0297 0.270313 15.8197 0.270313 18.7797 3.22031C21.7397 6.17031 21.7397 10.9803 18.7897 13.9303Z'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.88965 16.4902L8.18965 18.7902'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M13.5 10C14.3284 10 15 9.32843 15 8.5C15 7.67157 14.3284 7 13.5 7C12.6716 7 12 7.67157 12 8.5C12 9.32843 12.6716 10 13.5 10Z'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </g>;
};

export default createSvg(
    Key,
    'key',
    '0 0 22 22',
);
